import RestResource from '../rest.service';
import Service from '../api.service';

export default class QuotationsService extends RestResource {
  static _STATE_OPEN = 'open';
  static _STATE_CREATED = 'created';
  static _STATE_SENDED = 'sended';

  map(payload) {
    return {
      producer_id: payload.producerId,
      campaign_id: payload.campaignId,
      projection_id: payload.projectionId,
      first_payment_date: payload.firstPaymentDate,
      payments: payload.payments,
      dollar_quote: payload.dollarQuote,
      comment: payload.comment,
    };
  }

  stateRoute(id, state) {
    return this.getResource({ id: id }) + '/' + state;
  }

  confirm(id) {
    return Service.patch(this.stateRoute(id, QuotationsService._STATE_CREATED)).catch(this.handleErrors);
  }

  sendMail(id) {
    return Service.patch(this.stateRoute(id, QuotationsService._STATE_SENDED)).catch(this.handleErrors);
  }

  mapAttach(payload) {
    return {
      pictures: payload,
    };
  }

  getPdf(id, filename) {
    return Service.get(this.pdfResource(id), { responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }

  constructor() {
    super('quotations');
  }
}
